import env from "./properties/env.json"

class Utils {
  responsePageMaintenance(e) {
    console.log(e.response);
    if (e && e.response && e.response.status === env.STATUS_MAINTENANCE) {
      window.location = window.location.origin + "/" + `${env.STATUS_MAINTENANCE}`;
      return;
    }
  }
}
export default new Utils();